import axios from "axios";
export const sendExportable = async (selectedArticles, exportData, addNotification, options) => {
    const email = JSON.parse(sessionStorage.getItem("user"))?.email;
    const filteredData = exportData.filter(article =>
      selectedArticles.some(selected => selected.id_article === article.id_article)
    );
    const services = [options.generateDatasheet && 'data', options.generateDescriptions && 'desc', options.generateImages && 'img'].filter(Boolean);
    try {
      const articles = filteredData.map(article => ({
        id_version: article.version,
        id_article: article.id_article,
        id_retailer: article.id_retailer_array[0],
        id_category: article.id_category,
      }));
      const body = {
        articles,
        userEmail: email,
        services
      }
      const { data } = await axios.post(`${process.env.REACT_APP_EXPORT_ENDPOINT}`, body);
      const {statusCode} = data;
      const allSuccessful = statusCode === 202;
  
      if (allSuccessful) {
        addNotification('success', 'Su exportable se está procesando. Recibirá un correo cuando esté listo.');
      } else {
        addNotification('error', 'Error al enviar el exportable, contacate con soporte.');
      }

      return 
    } catch (error) {
      console.log(error);
      addNotification('error', 'Error al enviar el exportable');
    }
  };